import React, { useState } from "react";
import classes from "./DetailPageCouponModal.module.css";
import { useDetailPageCouponModal } from "../../Pregrine/DetailPageCouponModal/useDetailPageCouponModal";
import CopyToClipboard from "react-copy-to-clipboard";
import { useToasts } from "react-toast-notifications";

const DetailPageCouponModal = ({ productSku }) => {
  const availableCouponsProps = useDetailPageCouponModal(productSku);
  const { availableCoupons, toggleCoupons, buttonText, visibleCoupons } =
    availableCouponsProps;
  const { addToast } = useToasts();

  return (
    <>
      {availableCoupons?.length ? (
        <div className={classes.offersbox}>
          <h2>Offers and coupons (T&C apply)</h2>
          {availableCoupons.slice(0, visibleCoupons).map((coupon, idx) => (
            <div className={classes.offercoupons} key={idx}>
              <div
                className={`row d-flex align-items-center m-0 ${classes.brder}`}
              >
                <div className="col-md-9">
                  <div className={classes.offerlist}>
                    {coupon.name} ({coupon.description})
                  </div>
                </div>
                <div className="col-md-3 text-center">
                  <CopyToClipboard text={coupon.coupon_code}>
                    <div
                      className={classes.offertag}
                      onClick={() =>
                        addToast("Copied to clipboard", {
                          appearance: "success",
                          autoDismiss: true,
                          style: {
                            backgroundColor:
                              "#027B51" /* Custom background color */,
                            color: "#fff" /* Custom text color */,
                          },
                        })
                      }
                    >
                      {coupon.coupon_code}
                    </div>
                  </CopyToClipboard>
                </div>
              </div>
            </div>
          ))}
          {availableCoupons.length > 2 ? (
            <button
              className=" mb-3"
              style={{ fontWeight: "600", fontSize: "14px", color: " #42A9D6" }}
              onClick={toggleCoupons}
            >
              {buttonText}
            </button>
          ) : null}
        </div>
      ) : null}
    </>
  );
};

export default DetailPageCouponModal;
